<template lang="pug">
main
  PmHeader
  .container
    br
    article.message.is-link
      .message-header
        | Aplicación para firmar, enviar y autorizar comprobantes electrónicos
      .message-body
        | QuijoteLui, está construido para poder conectarse con la mayoría de las bases de datos.
        br
        a(href="https://mestizos.dev" target="_blank")
          h1.title mestizos.dev
    br
    footer.footer
      .content.has-text-centered
        p
          strong QuijoteLui version 1.0.0
          |  construido por
          |
          a(href="https://mestizos.dev" target="_blank") Mestizos Dev
          | . Parte del código fuente está licenciado bajo
          |
          a(href="https://opensource.org/licenses/GPL-3.0" target="_blank") GPL-3.0
          | .
    br
    PmFooter
</template>
<script>
import PmHeader from '../components/layout/Header.vue'
import PmFooter from '../components/layout/Footer.vue'

export default {
  components: {
    PmFooter, PmHeader
  }
} 
</script>

<style lang="scss" scoped>
.title {
  display: flex;
  justify-content: center;
}
.message-body {
  justify-content: center;
}
</style>
